import { combineReducers } from '@reduxjs/toolkit'
import { uiReducer } from './slices/uiSlice'
import { callReducer } from './slices/callSlice'

/**
 * Combine all slice reducers
 */
export const rootReducer = combineReducers({
  ui: uiReducer,
  call: callReducer,
})
